import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { unauthenticated } from '@datev/ngx-dcal';
import { map, Observable } from 'rxjs';
import {
  DownloadType,
  Product,
  ProductDto,
  ProductPage,
  ProductPageDto,
} from '../../model';
import { ProductGroupMapperService } from './product-group-mapper.service';

type ProductFilter = {
  productGroup?: string | null;
  name?: string;
};

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private apiUrl = 'api/amr/download-portal-api/v1/additional-software';

  constructor(
    private readonly http: HttpClient,
    private readonly productGroupMapper: ProductGroupMapperService,
  ) {}

  public getProducts(
    filter: ProductFilter | null,
    pageNumber: number,
    pageSize: number,
  ): Observable<ProductPage> {
    let params = new HttpParams();

    if (filter && Object.keys(filter).length > 0) {
      if (
        filter.productGroup &&
        filter.productGroup !== 'KEINE_PRODUKTGRUPPE'
      ) {
        params = params.append('product_group', filter.productGroup);
      }
      if (filter.name) {
        params = params.append('name', filter.name);
      }
    }
    params = params.append('page', pageNumber);
    params = params.append('page_size', pageSize);

    return this.http
      .get<ProductPageDto>(`${this.apiUrl}?${params.toString()}`, {
        context: unauthenticated(),
      })
      .pipe(
        map(productPageDto => {
          const content =
            productPageDto.content?.map(productDto =>
              this.mapProductDtoToProduct(productDto),
            ) || [];
          return { ...productPageDto, content };
        }),
      );
  }

  public getProductById(id: string): Observable<Product> {
    return this.http
      .get<ProductDto>(`${this.apiUrl}/${id}`, {
        context: unauthenticated(),
      })
      .pipe(map(productDto => this.mapProductDtoToProduct(productDto)));
  }

  private mapProductDtoToProduct(productDto: ProductDto): Product {
    const productGroupLabel = this.productGroupMapper.getProductGroupLabel(
      productDto.product_group,
    );
    const displayTitle = productDto.version
      ? `${productDto.name} ${productDto.version}`
      : productDto.name;

    return {
      ...productDto,
      productGroupLabel,
      displayTitle,
      type: DownloadType.PRODUKT,
    };
  }
}
